module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-search"
  }, [_c('header', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": "logo"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.closeIcon,
      "alt": "logo"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })]), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "search-area-wrap"
  }, [_c('div', {
    staticClass: "search-area"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.keyword),
      expression: "!keyword"
    }],
    attrs: {
      "src": _vm.searchIcon,
      "alt": "search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": this.$i18n.locale === 'zh-CN' ? '搜索' : 'Search'
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-micro",
    on: {
      "click": _vm.openVoiceModal
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.keyword = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n.locale === 'zh-CN' ? '取消' : 'cancel'))])]), _vm._v(" "), (!_vm.keyword) ? _c('ul', {
    staticClass: "nav-list"
  }, [_vm._l((_vm.lists), function(list, index) {
    return _c('li', {
      key: index,
      class: {
        'actived': list.isSelected
      },
      on: {
        "click": function($event) {
          _vm.expandList(list, index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n.locale === 'zh-CN' ? list.title : list.title_en) + "\n          "), (index !== 1) ? _c('img', {
      attrs: {
        "src": _vm.arrowDown,
        "alt": "arrow"
      }
    }) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "collapse"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (list.isSelected),
        expression: "list.isSelected"
      }],
      ref: "content",
      refInFor: true,
      staticClass: "content"
    }, _vm._l((list.content), function(item, index) {
      return _c('span', {
        key: index + 1000,
        on: {
          "click": function($event) {
            _vm.$router.push({
              name: item.name,
              path: item.path
            });
            _vm.$emit('close')
          }
        }
      }, [_vm._v(_vm._s(_vm.$i18n.locale === 'zh-CN' ? item.title : item.title_en))])
    }))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "language-toggle"
  }, [_c('span', {
    class: {
      none: _vm.$i18n.locale !== 'zh-CN'
    },
    on: {
      "click": function($event) {
        _vm.setLang('zh-CN')
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    class: {
      none: _vm.$i18n.locale === 'zh-CN'
    },
    on: {
      "click": function($event) {
        _vm.setLang('en-US')
      }
    }
  }, [_vm._v("EN")])])], 2) : _c('div', {
    staticClass: "search-results"
  }, [_c('ul', {
    staticClass: "categories"
  }, _vm._l((_vm.categories), function(cate, index) {
    return _c('li', {
      key: index,
      class: {
        current: cate.type === _vm.category
      },
      on: {
        "click": function($event) {
          _vm.category = cate.type
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$i18n.locale === 'zh-CN' ? cate.name : cate.name_en) + "\n        ")])
  })), _vm._v(" "), _c('ul', {
    staticClass: "results"
  }, _vm._l((_vm.currentResults), function(result, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.viewResult(result)
        }
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.judgeCategory(result.category)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$i18n.locale === 'zh-CN' ?
      result.name || (result.article && (result.article.title || result.article.title_en)) :
      result.name_en || result.name || (result.article && (result.article.title_en || result.article.title))))])])
  }))])]), _vm._v(" "), (_vm.showVoiceModal) ? _c('div', {
    staticClass: "voice-modal"
  }, [_c('img', {
    attrs: {
      "src": _vm.closeIcon,
      "alt": "logo"
    },
    on: {
      "click": _vm.closeVoiceModal
    }
  }), _vm._v(" "), _c('h2', [_vm._v("说出你想找什么")]), _vm._v(" "), (!_vm.isMsgVisible) ? [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 0),
      expression: "step === 0"
    }],
    staticClass: "top-span"
  }, [_vm._v("长按按钮开启语音识别")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 1),
      expression: "step === 1"
    }],
    staticClass: "top-span"
  }, [_c('div', [_vm._v("正在倾听...")]), _vm._v(" "), _c('div', {
    staticClass: "release-up"
  }, [_vm._v("松开停止录音...")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 2),
      expression: "step === 2"
    }],
    staticClass: "top-span"
  }, [_vm._v("正在识别中...")])] : _c('div', {
    staticClass: "top-span error"
  }, [_c('span', [_vm._v("没听清，试试说“研究院简介”")]), _vm._v(" "), _c('ul', {
    staticClass: "rec"
  }, _vm._l((['研究生培养', '研究方向', '新一代人工智能理论']), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.jumpSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === (1 || 2)),
      expression: "step === (1 || 2)"
    }],
    staticClass: "siri-wave"
  }), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "bottom-span mic-btn",
    on: {
      "touchstart": _vm.start,
      "touchend": _vm.endRecord
    }
  }, [_c('i', {
    staticClass: "iconfont icon-micro"
  })])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6600b8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-search.vue
// module id = 676
// module chunks = 57